import React from 'react';

const SelfPrimingCentrifugalPumpIcon = ({
  width = 64,
  height = 64,
  className = '',
  startColor = '#373737',
  midColor = '#EBEBEB',
  endColor = '#373737'
}) => {
  const uid = React.useId ? React.useId() : 'sc' + Math.random().toString(36).substr(2, 9);

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      viewBox="0 0 112.5 54.842"
      className={className}
    >

<g id={`${uid}_1`}>
	<path fill={`${startColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M2.815,44.481h29.279v1.578H2.815V44.481z" />
	
		<linearGradient id={`${uid}_2`} gradientUnits="userSpaceOnUse" x1="17.8481" y1="10.584" x2="17.8481" y2="35.8101" gradientTransform="matrix(1 0 0 -1 0 54.8418)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_2)`} stroke={`${startColor}`} strokeWidth="0.25" d="M2.815,44.257h30.63l2.252-1.802V21.059l-2.252-2.027h-0.45   h-0.451H2.815l-2.478,2.14L0,22.41v0.225v0.676v17.342l1.352,2.929l1.239,0.676L2.815,44.257" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M6.419,44.257v-25" />
</g>
<g id={`${uid}_3`}>
	<path fill={`${startColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M35.022,22.41h2.928v18.692h-2.928V22.41z" />
	
		<linearGradient id={`${uid}_4`} gradientUnits="userSpaceOnUse" x1="61.8242" y1="11.2598" x2="61.8242" y2="36.4858" gradientTransform="matrix(1 0 0 -1 0 54.8418)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_4)`} stroke={`${startColor}`} strokeWidth="0.25" d="M38.176,18.356h47.297v25.226H38.176V18.356z" />
	<path fill={`${midColor}`} d="M38.401,19.031h46.396v6.531H38.401V19.031z" />
	<path fill="none" stroke={`${startColor}`} strokeWidth="0.25" d="M33.221,44.257v-25" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M37.5,43.131h47.973v5.854H37.5V43.131z" />
	<path fill={`${startColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M53.716,45.608h31.757v3.379H53.716V45.608z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M54.392,21.959v-3.378H52.59v3.378v0.226l0.112,0.112l0.113,0.226   l0.112,0.112l0.113,0.112l0.113,0.113h0.225h0.113h0.225h0.112l0.113-0.113l0.225-0.112l0.113-0.112v-0.226l0.113-0.112V21.959   L54.392,21.959z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M71.959,21.959v-3.378h-1.801v3.378v0.226l0.111,0.112v0.226   l0.112,0.112l0.226,0.112l0.113,0.113h0.112h0.226h0.112h0.226l0.111-0.113l0.112-0.112l0.112-0.112l0.113-0.226l0.111-0.112   v-0.226H71.959z" />
</g>
<g id={`${uid}_5`}>
	
		<linearGradient id={`${uid}_6`} gradientUnits="userSpaceOnUse" x1="93.9199" y1="5.1797" x2="93.9199" y2="43.2427" gradientTransform="matrix(1 0 0 -1 0 54.8418)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_6)`} stroke={`${startColor}`} strokeWidth="0.25" d="M85.473,11.599v38.063h16.894V11.599H85.473" />
	<path fill={`${startColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M89.527,11.599h10.586v38.063H89.527V11.599z" />
	<path fill={`${startColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M85.473,6.194h16.894v5.405H85.473V6.194z" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M86.6,10.473V6.869h14.639" />
</g>
<g id={`${uid}_7`}>
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M89.527,37.95h10.586v1.802H89.527V37.95z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M89.527,45.608h10.586v1.576H89.527V45.608z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M89.527,30.293h10.586v1.802H89.527V30.293z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M89.527,21.509h10.586v1.802H89.527V21.509z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M89.527,13.852h10.586v1.802H89.527V13.852z" />
</g>
<g id={`${uid}_8`}>
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M7.545,42.906h9.91v-13.74h-9.91V42.906z" />
	<path fill="none" stroke={`${midColor}`} strokeWidth="0.25" d="M8.221,42.455V30.067h8.559" />
	<circle fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" cx="19.482" cy="43.469" r="2.027" />
</g>
<g id={`${uid}_9`}>
	
		<linearGradient id={`${uid}_10`} gradientUnits="userSpaceOnUse" x1="91.7793" y1="50.5625" x2="95.834" y2="50.5625" gradientTransform="matrix(1 0 0 -1 0 54.8418)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_10)`} stroke={`${startColor}`} strokeWidth="0.25" d="M91.779,2.14h4.055v4.279h-4.055V2.14" />
	
		<linearGradient id={`${uid}_11`} gradientUnits="userSpaceOnUse" x1="85.4727" y1="53.6592" x2="102.1406" y2="53.6592" gradientTransform="matrix(1 0 0 -1 0 54.8418)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_11)`} stroke={`${startColor}`} strokeWidth="0.25" d="M85.473,0h16.668v2.364H85.473V0" />
</g>
<g id={`${uid}_12`}>
	
		<linearGradient id={`${uid}_13`} gradientUnits="userSpaceOnUse" x1="102.3652" y1="33.6709" x2="107.0938" y2="33.6709" gradientTransform="matrix(1 0 0 -1 0 54.8418)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_13)`} stroke={`${startColor}`} strokeWidth="0.25" d="M102.365,9.121h4.729v24.101h-4.729V9.121z" />
	
		<linearGradient id={`${uid}_14`} gradientUnits="userSpaceOnUse" x1="107.3203" y1="21.6201" x2="107.3203" y2="31.5308" gradientTransform="matrix(1 0 0 -1 0 54.8418)">
		<stop offset="0.01" style={{stopColor: `${endColor}`}} />
		<stop offset="0.51" style={{stopColor: `${midColor}`}} />
		<stop offset="1" style={{stopColor: `${endColor}`}} />
	</linearGradient>
	<path fill={`url(#${uid}_14)`} stroke={`${startColor}`} strokeWidth="0.25" d="M102.365,33.222h9.91v-9.911h-5.182" />
</g>
<g id={`${uid}_15`}>
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M1.915,43.806h2.252v5.631H1.915V43.806z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M10.248,43.806h2.027v5.631h-2.027V43.806z" />
	<path fill={`${endColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M29.842,43.806h2.252v5.631h-2.252V43.806z" />
	<path fill={`${midColor}`} stroke={`${startColor}`} strokeWidth="0.25" d="M0,49.212h107.32v5.63H0V49.212z" />
</g>
    </svg>
  );
};

export default SelfPrimingCentrifugalPumpIcon;
